import { z } from "zod";
import { ProjectIdSchema } from "../primitives/ids.js";
import { ClaimIdSchema } from "./agency-unlock.js";
import { ReportIdSchema } from "../primitives/ids.js";
import { PublicScanTopIssueV1Schema } from "./public-scan.js";
export const PROOF_RELAUNCH_PROJECT_STATUS = "PROOF_RELAUNCH_TEMPLATE";
export const RelaunchPreviewIdSchema = z
    .string()
    .regex(/^rlpv_[a-zA-Z0-9_-]+$/)
    .brand();
export const RelaunchPreviewStatusSchema = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETE",
    "FAILED",
]);
export const RelaunchPreviewIssueSectionV1Schema = z
    .object({
    title: z.string().min(1),
    detail: z.string().min(1),
    sourceCheckId: z.string().min(1).optional(),
})
    .strict();
export const RelaunchPreviewProposalSectionV1Schema = z
    .object({
    title: z.string().min(1),
    detail: z.string().min(1),
    improvementKind: z.enum(["STRUCTURE", "CONTENT", "LEAD_PATH", "TRUST", "METADATA"]),
})
    .strict();
/** Worker-persisted relaunch preview artifact. */
export const RelaunchPreviewArtifactV1Schema = z
    .object({
    schemaVersion: z.literal("relaunch-preview-artifact.v1.0"),
    relaunchPreviewId: RelaunchPreviewIdSchema,
    claimId: ClaimIdSchema,
    publicReportRef: ReportIdSchema,
    projectId: ProjectIdSchema,
    draftId: z.string().min(1),
    templateKind: z.literal("PROOF_RELAUNCH"),
    generatedAt: z.string().datetime(),
    sourceScore: z.number().int().min(0).max(100),
    sourceScoreLabel: z.string().min(1),
    scannedUrl: z.string().url(),
    currentIssues: z.array(RelaunchPreviewIssueSectionV1Schema).min(1).max(10),
    proposedRelaunch: z.array(RelaunchPreviewProposalSectionV1Schema).min(1).max(10),
    draftProposalNote: z.string().min(1),
    topIssuesSnapshot: z.array(PublicScanTopIssueV1Schema).max(5),
    disclaimers: z.array(z.string().min(1)).min(1),
})
    .strict();
/** Agency view returned by GET relaunch preview routes. */
export const AgencyRelaunchPreviewViewV1Schema = z
    .object({
    schemaVersion: z.literal("agency-relaunch-preview-view.v1.0"),
    relaunchPreviewId: RelaunchPreviewIdSchema,
    claimId: ClaimIdSchema,
    publicReportRef: ReportIdSchema,
    projectId: ProjectIdSchema,
    draftId: z.string().min(1),
    status: RelaunchPreviewStatusSchema,
    templateKind: z.literal("PROOF_RELAUNCH"),
    generatedAt: z.string().datetime().optional(),
    sourceScore: z.number().int().min(0).max(100).optional(),
    sourceScoreLabel: z.string().min(1).optional(),
    scannedUrl: z.string().url().optional(),
    currentIssues: z.array(RelaunchPreviewIssueSectionV1Schema).optional(),
    proposedRelaunch: z.array(RelaunchPreviewProposalSectionV1Schema).optional(),
    draftProposalNote: z.string().min(1).optional(),
    disclaimers: z.array(z.string().min(1)).optional(),
    idempotentReplay: z.boolean(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
/** POST generate accepted (202) response. */
export const RelaunchPreviewGenerateAcceptedV1Schema = z
    .object({
    schemaVersion: z.literal("relaunch-preview-generate-accepted.v1.0"),
    status: z.literal("PENDING"),
    claimId: ClaimIdSchema,
    relaunchPreviewId: RelaunchPreviewIdSchema,
})
    .strict();
export const RelaunchPreviewDraftSourceSchema = z.literal("SCAN_REPORT_PROPOSAL");
export const PROOF_RELAUNCH_DRAFT_STATUS = "DRAFT";
//# sourceMappingURL=relaunch-preview.js.map